'use strict';

import angular from 'angular';


export default function($log, $http) {
	'ngInject';

	var vm = {
		data: {
			users: {},
		},
	};

	$http.get('/api/entity/').then(function success(response) {
		// Remove Staff from data
		for(var i = 0; i < response.data.roles.length; i++) {
			var role = response.data.roles[i];
			if (role.display_name == '_Staff') {
				response.data.roles.splice(i, 1);
				i--;
			} else {
				for (var user of role.users) {
					vm.data.users[user.uuid] = user;
				}
			}
		}
		angular.merge(vm.data, response.data);
		vm.data.userArray = Object.keys(vm.data.users).map(function(key) {
			  return vm.data.users[key];
		})
		// vm.data.userArray = Object.values(vm.data.users);
	}, function error(response) {
		$log.error(response);
	});

	return vm;
}
